import React, { Fragment, useState, useEffect } from 'react'
import PropTypes from 'prop-types'
import ChatMessagesListView from '../component/ChatMessagesListView'
import ChatMessage from '../../ChatMessage/container/ChatMessage'
import moment from 'moment'
import ChatSpyHeaderInfoView from '../component/ChatSpyHeaderInfoView'
import { getMissionViewDataById } from '../../../../Module/graphQL'
import { PATHS } from '../../../../Config/Routing/paths'
import { format } from 'date-fns'

const ChatMessagesList = ({ messages, conversation, isSpyChat }) => {
  const [headerLinks, setHeaderLinks] = useState([])
  const isSpy = isSpyChat && conversation && conversation.missionId

  useEffect(() => {
    if (conversation && conversation.missionId) {
      getMission(conversation.missionId)
      setHeaderLinks([])
    }
  }, [conversation && conversation.missionId])

  const getMission = async missionId => {
    const response = await getMissionViewDataById(missionId)
    const result = await response.json()
    const { mission } = result.data

    if (mission) {
      getHeaders(mission)
    }
  }

  const getHeaders = mission => {
    const {
      id,
      client,
      campaign,
      dateTime,
      location,
      type,
      cityPlan: { city },
      user,
    } = mission
    const headers = []

    if (client) {
      headers.push({
        title: client.name,
        link: `${PATHS.main.dashboard}/clients/${client.id}`,
      })
    }

    if (campaign) {
      headers.push({
        title: campaign.name,
        link: `${PATHS.main.dashboard}/campaigns/${
          campaign.id
        }/dashboard/overview`,
      })
    }

    if (dateTime) {
      const time = format(new Date(dateTime), 'HH:mm')
      headers.push({
        title: time,
        link: `${PATHS.main.dashboard}/mission/${id}`,
      })
    }

    if (location) {
      headers.push({
        title: location.name,
        link: `${PATHS.main.dashboard}/cities/${
          city.id
        }/locations/${type.toLowerCase()}?tableSearch=${location.name}`,
      })
    }

    if (user) {
      headers.push({
        title: `${user.firstName} ${user.lastName}`,
        link: `${PATHS.main.dashboard}/cities/${city.id}/ambassadors/${
          user.id
        }`,
      })
    }

    setHeaderLinks(headers)
  }

  const messagesJSX = messages.map(message => {
    const {
      text,
      authorId,
      name,
      timestamp,
      status,
      isOwnMessage,
      type,
      fileURL,
      id,
    } = message
    const time = moment(timestamp).format('HH:mm D MMM')
    return (
      <ChatMessage
        key={id + authorId + timestamp}
        text={text}
        author={name}
        time={time}
        isOwnMessage={isOwnMessage}
        status={status}
        type={type}
        fileURL={fileURL}
      />
    )
  })

  return (
    <Fragment>
      {isSpy && <ChatSpyHeaderInfoView headerLinks={headerLinks} />}
      <ChatMessagesListView>{messagesJSX}</ChatMessagesListView>
    </Fragment>
  )
}

ChatMessagesList.propTypes = {
  messages: PropTypes.array,
}

export default ChatMessagesList
